import { render } from "./AddNewPassword.vue?vue&type=template&id=bb686ea2&ts=true"
import script from "./AddNewPassword.vue?vue&type=script&lang=ts"
export * from "./AddNewPassword.vue?vue&type=script&lang=ts"

import "./AddNewPassword.vue?vue&type=style&index=0&id=bb686ea2&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__